<template>
    <div class="app-container">
    <el-row class="headTop">
      <el-col :span="2" :offset="22">
        <el-button style="width:100%"   type="success" icon="el-icon-circle-plus-outline" @click="showDialog()">新增</el-button>
      </el-col>
    </el-row>
    <el-dialog title="消息推送员工配置"  :visible.sync="dialogVisible" width="1000px">
       <el-form :model="formparams" :rules="rules" ref="formparams" label-width="120px">
         <el-form-item label="类型" prop="typeId">
            <el-select v-model="formparams.typeId"
              placeholder="请选择"
            >
              <el-option v-for="item in this.types"
              :key="item.id"
              :label="item.name"
              :value="item.typeId"
              ></el-option>
            </el-select>
          </el-form-item>
         <el-form-item label="员工" prop="eid">
            <el-select v-model="formparams.eid"
              placeholder="请选择"
              @change="getName(formparams.eid)"
            >
              <el-option v-for="item in this.employeeS"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button style="width:100px"  @click="resetForm('formparams')">取 消</el-button>
          <el-button style="width:100px"  type="primary" @click="submitForm('formparams')">确 定</el-button>
        </span>
    </el-dialog>
    <el-row class="tableList">
      <el-table v-loading="loading" :data="tableData" height="82vh" border stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column prop="name" label="员工姓名"></el-table-column>
        <el-table-column label="类型">
          <template slot-scope="scope">
            <div>{{scope.row.typeName}}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="remark" label="说明"></el-table-column> -->
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button style="width:100px"  type="primary" @click="edit(scope.row)">编辑</el-button>
            <el-button style="width:100px"  type="danger" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
let that;
import {getTbEPushMessage, getInfE, insertTbEPushMessage,deleteTbEPushMessage, updateTbEPushMessage,getTbEPushMessageModel} from "../../api/configApi";
import mainHead from "../../components/mainHead/mainHead";
export default {
  data() {
    return {
      loading: true,
      dialogVisible: false,
      addType:1,
      employeeS:[],
      titleList:[],
      types:[],
      formparams:{
        typeId:'',
        eid:'',
        name:''
      },
      newData:'',
      rules:{
        typeId: [
          { required: true, message: '请选择活动区域', trigger: 'change' }
        ],
        eid:[
          { required: true, message: '请选择员工', trigger: 'change' }
        ]
      },
      formData:{},
      fileList:[],//图片回显示
      tableData:[]
    }
  },
  components: {
    mainHead
  },
  beforeCreate(){
    // that = this;
  },
  created(){
  },
  mounted() {
    this.getInfE()
    this.getTbEPushMessageModel()
    this.getTableList()
  },
  methods: {
    showDialog(){
      this.formparams.typeId = ''
      this.formparams.eid= ''
      this.dialogVisible = true
      this.addType=1
    },
    getName(eid){
      for (let i = 0; i < this.employeeS.length; i++) {
        if(this.employeeS[i].id==eid){
          this.formparams.name=this.employeeS[i].name
        }
      }
    },
    //获取员工信息
    getInfE(){
      getInfE().then(res=>{
        this.employeeS = res.data
        console.log(res)
      })
    },
    //查询员工推送模板信息 (找出类型)
    getTbEPushMessageModel(){
      getTbEPushMessageModel().then(res=>{
        this.types = res.data
      })
    },
    getTableList(){
      getTbEPushMessage().then((res)=>{
        console.log(res)
        this.loading = false
        this.tableData = res.data
      })
    },
    filterHandler(value, row, column) {
      return row.shopNum === value;
    },
    //编辑
    edit(row){
      console.log(row)
      this.addType = 2
      this.formparams.typeId = row.typeId
      this.formparams.id = row.id
      this.formparams.eid = row.eid
      this.dialogVisible = true
    },
    remove(row){
      this.$confirm('此操作将永久删除该消息模板, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteTbEPushMessage({id:row.id}).then(res=>{
            if(res.msg == 'success'){
              this.$message({
                type:'success',
                message:'删除成功'
              })
            } else{
              this.$message.error(res.data)
            }
            this.dialogVisible = false
            this.getTableList()
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    submitForm(formparams){
      this.$refs[formparams].validate(valid => {
        if (valid) {
          if(this.addType==1){
            insertTbEPushMessage(this.formparams).then(res=>{
              if(res.msg == 'success'){
                this.$message({
                  type:'success',
                  message:'添加成功'
                })
              } else{
                this.$message.error(res.data)
              }
              this.dialogVisible = false
              this.getTableList()
            })
          } else{
            updateTbEPushMessage(this.formparams).then(res=>{
              if(res.msg == 'success'){
                this.$message({
                  type:'success',
                  message:'修改成功'
                })
              } else{
                this.$message.error(res.data)
              }
              this.dialogVisible = false
              this.getTableList()
            })
          }
        } else {
          this.$message.error('请检查必填项');
          return false;
        }
      });
    },
    //取消
    resetForm(formparams) {
      this.dialogVisible = false;
      this.$refs[formparams].clearValidate();
    }
  }
};
</script>
<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// newMemberConfig.vue?7c63c9fe